module.exports = (__parcel__import__("4UBhy")).then(() => parcelRequire('fyWP3'));